export function cx(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

export const labelClass = 'text-sm font-medium text-slate-800';
export const hintClass = 'text-xs text-slate-500';
export const errorClass = 'text-xs font-medium text-red-600';

export const fieldText = 'text-base pointer-fine:text-sm';
export const fieldHeight = 'h-10 pointer-coarse:h-11';

const fieldSurface =
  'rounded-xl border border-slate-200 bg-white text-slate-900 shadow-[inset_0_1px_2px_rgb(15_23_42/0.05)] outline-none transition duration-150';

export const controlBase = `w-full ${fieldSurface} placeholder:text-slate-400 hover:border-slate-300 focus:border-brand-500 focus:ring-4 focus:ring-brand-500/15 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500 aria-invalid:border-red-400 aria-invalid:bg-red-50/30 aria-invalid:focus:ring-red-500/15`;

export const controlClass = `${controlBase} ${fieldText}`;

export const triggerClass = `flex ${fieldHeight} w-full items-center justify-between gap-2 px-3 text-left ${fieldSurface} ${fieldText} hover:border-slate-300 data-focus-visible:border-brand-500 data-focus-visible:ring-4 data-focus-visible:ring-brand-500/15 data-pressed:border-brand-500 data-pressed:ring-4 data-pressed:ring-brand-500/15 data-disabled:cursor-not-allowed data-disabled:bg-slate-50 data-disabled:text-slate-500`;

export const groupFieldClass = `flex ${fieldHeight} w-full items-center pr-1 pl-3 ${fieldSurface} ${fieldText} hover:border-slate-300 data-focus-within:border-brand-500 data-focus-within:ring-4 data-focus-within:ring-brand-500/15 data-invalid:border-red-400 data-disabled:bg-slate-50`;

export const popoverClass =
  'overflow-hidden rounded-xl border border-slate-200 bg-white shadow-raised outline-none data-entering:animate-pop-in data-exiting:animate-pop-out';

export const optionClass =
  'group flex cursor-default items-center gap-2 rounded-lg px-2.5 py-2 text-sm text-slate-800 outline-none pointer-coarse:py-3 data-focused:bg-slate-100 data-selected:font-medium data-selected:text-brand-800 data-disabled:opacity-50';
